module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\n    Your email is not verified !\n    "), _c('span', {
    staticClass: "click-here",
    on: {
      "click": _vm.resendEmailVerficationLink
    }
  }, [_vm._v("\n      Click here\n    ")]), _vm._v("\n    to resend verification link to your registered email address ! ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5aa5b1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/verifyEmail.vue
// module id = 530
// module chunks = 17